export const es_text: Record<string, string> = {
  "Sign in to your Lulu Loyal account to access all our features.":
    "Inicia sesión en tu cuenta de Lulu Loyal para acceder a todas nuestras funciones.",
  "Don't have an account?": "¿No tienes una cuenta?",
  "Click here to create one.": "Haz clic aquí para crear una.",
  "Create Lulu Loyal Account": "Crear Cuenta de Lulu Loyal",
  "Log In To Lulu Loyal": "Iniciar Sesión en Lulu Loyal",
  "Forgot Password?": "¿Olvidaste tu Contraseña?",
  "Confirm Delete": "Confirmar Eliminación",
  "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.":
    "¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer y cancelará cualquier suscripción activa.",
  "Delete Permanently": "Eliminar Permanentemente",
  "Confirm Logout": "Confirmar Cierre de Sesión",
  "Are you sure you want to logout?":
    "¿Estás seguro de que quieres cerrar sesión?",
  "Password Recovery": "Recuperación de Contraseña",
  "Enter your email address to receive a login link.":
    "Ingresa tu dirección de correo electrónico para recibir un enlace de inicio de sesión.",
  "Send Recovery Email": "Enviar Correo de Recuperación",
  "Recovery email sent. Please check your inbox.":
    "Correo de recuperación enviado. Por favor revisa tu bandeja de entrada.",
  "Account updated successfully.": "Cuenta actualizada con éxito.",
  "How Lulu Works": "Cómo funciona Lulu",
  "100% untraceable": "100% imposible de rastrear",
  "Just share the username": "Solo comparte el nombre de usuario",
  "No Login Required": "No requiere iniciar sesión",
  "Invalid login link": "Enlace de inicio de sesión inválido",
  "Signing you in...": "Iniciando sesión...",
  Loading: "Cargando",
  "Analyzing {username}": "Analizando {username}",
  seconds: "segundos",
  "Figuring out who they follow": "Descubriendo a quién siguen",
  "Looking at who follows them": "Viendo quién los sigue",
  "Figuring out who's new": "Descubriendo quién es nuevo",
  "Looking for suspicious profiles": "Buscando perfiles sospechosos",
  "Taking a closer look": "Mirando más de cerca",
  "Looking through off-site content": "Revisando contenido externo",
  "Analyzing behavior patterns": "Analizando patrones de comportamiento",
  "Checking for red flags": "Buscando señales de alerta",
  "Wrapping up (this can take a while)":
    "Finalizando (esto puede tomar un momento)",
  "Finding stories": "Encontrando historias",
  "Loading story content": "Cargando contenido de historias",
  "Processing media": "Procesando medios",
  "Preparing anonymous view": "Preparando vista anónima",
  Finalizing: "Finalizando",
  "Email Address": "Correo electrónico",
  Save: "Guardar",
  "Delete Account": "Eliminar cuenta",
  "@username": "@usuario",
  "Reveal Follows": "Revelar seguidos",
  "Anonymously View Stories": "Ver historias anónimamente",
  "find red flags": "encontrar señales de alerta",
  "Best Results": "Mejores resultados",
  "Search over a billion accounts": "Busca en más de mil millones de cuentas",
  "Is this legal?": "¿Es esto legal?",
  "Lulu Loyal": "Lulu Loyal",
  LINKS: "ENLACES",
  Prices: "Precios",
  Resources: "Recursos",
  LEGAL: "LEGAL",
  "Privacy Policy": "Política de privacidad",
  "Terms of Use": "Términos de uso",
  "Refund Policy": "Política de reembolso",
  "CONTACT US": "CONTÁCTANOS",
  "support@lululoyal.com": "support@lululoyal.com",
  "© 2025 Lulu Loyal. All Rights Reserved.":
    "© 2025 Lulu Loyal. Todos los derechos reservados.",
  "Manage Account": "Administrar cuenta",
  Login: "Iniciar sesión",
  Anonymity: "Anonimato",
  "Secure + Untraceable": "Seguro + Imposible de rastrear",
  "Security Risks": "Riesgos de seguridad",
  Pricing: "Precios",
  "Lowest Prices": "Precios más bajos",
  "Pretends to Be Free": "Pretende ser gratis",
  Speed: "Velocidad",
  "Fastest + Best Results": "Más rápido + Mejores resultados",
  "Slow + Poor Results": "Lento + Malos resultados",
  Quality: "Calidad",
  "Unmatched Accuracy": "Precisión incomparable",
  "Consistent Errors": "Errores constantes",
  Features: "Características",
  "Best Features": "Mejores características",
  "Limited Features": "Características limitadas",
  "Insta/TikTok/Snap": "Insta/TikTok/Snap",
  "All 3": "Los 3",
  "Only Instagram": "Solo Instagram",
  "Everyone Else": "Todos los demás",
  "🌶️ Porn account": "🌶️ Cuenta porno",
  "🍒 Baddie": "🍒 Chica mala",
  "🍑 Spicy content": "🍑 Contenido picante",
  "No Red Flags": "Sin señales de alerta",
  "Follows back": "Sigue de vuelta",
  "No follow back": "No sigue de vuelta",
  "Subscribe to reveal all": "Suscríbete para revelar todo",
  "{number} new girls": "{number} chicas nuevas",
  "{number} new guys": "{number} chicos nuevos",
  "{number} Others": "{number} otros",
  "Subscribe to Reveal All": "Suscríbete para revelar todo",
  "{number} RED FLAGS": "{number} SEÑALES DE ALERTA",
  "{number} SUS PROFILES": "{number} PERFILES SOSPECHOSOS",
  "Updated {hours}h ago": "Actualizado hace {hours}h",
  "This account is private": "Esta cuenta es privada",
  "Notify Me": "Notifícame",
  "Reveal More": "Revelar más",
  "UPDATED {hours} HOURS AGO": "ACTUALIZADO HACE {hours} HORAS",
  "Stories from @{username}": "Historias de @{username}",
  "Refresh Stories": "Actualizar historias",
  "{number} STORIES": "{number} HISTORIAS",
  "ANONYMOUS VIEWING": "VISTA ANÓNIMA",
  "Subscribe to view": "Suscríbete para ver",
  "User Not Found": "Usuario no encontrado",
  "Try Again": "Intentar de nuevo",
  "Results for": "Seguidos más recientes de:",
  "+{number} more": "+{number} más",
  "View All Recent Followers": "Ver todos los seguidores recientes",
  "See Who They Followed": "Ver a quién siguieron",
  "Recent Follows": "Seguidos Recientes",
  "Recent Followers": "Seguidores Recientes",
  "Thank You!": "¡Gracias!",
  "Your subscription is now active.": "Tu suscripción está ahora activa.",
  "You now have full access to all Lulu Loyal features.":
    "Ahora tienes acceso completo a todas las funciones de Lulu Loyal.",
  "Start Analyzing": "Comenzar Análisis",
  "Create a Lulu Loyal account to access all our features.":
    "Crea una cuenta de Lulu Loyal para acceder a todas nuestras funciones.",
  "If you have an account, ": "Si tienes una cuenta, ",
  "you can login by clicking here.":
    "puedes iniciar sesión haciendo clic aquí.",
  "My Account": "Mi Cuenta",
  "Change Email Address": "Cambiar Dirección de Correo",
  "Change Password": "Cambiar Contraseña",
  "Manage Subscription": "Administrar Suscripción",
  "You are already subscribed": "Ya estás suscrito",
  "Account not found": "Cuenta no encontrada",
  "View All": "Ver Todo",
  Girls: "Chicas",
  Guys: "Chicos",
  Other: "Otro",
  All: "Todos",
  "Lulu Loyal's FAQ": "Preguntas Frecuentes de Lulu Loyal",
  "Why Use Lulu Loyal?": "¿Por qué usar Lulu Loyal?",
  "PER WEEK": "POR SEMANA",
  "Stop guessing, learn the truth, and reduce your anxiety levels with Lulu Loyal's tools.":
    "Deja de adivinar, conoce la verdad y reduce tus niveles de ansiedad con las herramientas de Lulu Loyal.",
  "Unlimited access to all tools.":
    "Acceso ilimitado a todas las herramientas.",
  "No commitment, cancel any time.":
    "Sin compromiso, cancela en cualquier momento.",
  "Free relationship anxiety guide.":
    "Guía de ansiedad en las relaciones gratis.",
  "Get Unlimited Access": "Obtener Acceso Ilimitado",
  "User Reviews": "Reseñas de Usuarios",
  "Step 1 - Enter a Username": "Paso 1 - Ingresa un Nombre de Usuario",
  "Enter a username to start the search.":
    "Ingresa un nombre de usuario para iniciar la búsqueda.",
  "Step 2 - Anonymous Search": "Paso 2 - Búsqueda Anónima",
  "Do an untraceable, anonymous search.":
    "Realiza una búsqueda anónima e imposible de rastrear.",
  "Step 3 - Best Results": "Paso 3 - Mejores Resultados",
  "Receive the best results, learn the truth.":
    "Recibe los mejores resultados, conoce la verdad.",
  "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!":
    "¡Vi instantáneamente a quién acababa de seguir mi novio! ¡Me libré de tanta ansiedad!",
  "- Sophie": "- Sophie",
  "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲":
    "Mi ex estaba siguiendo modelos de OnlyFans... como 4 de ellas 😭😭😭 Al menos lo dejé a tiempo 🥲",
  "- Osheb": "- Osheb",
  "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.":
    "Noté que mi pareja seguía muchas cuentas nuevas cada día... resultó que no era nada, fue bueno verificar.",
  "- Anonymous": "- Anónimo",
  "Most recent follow": "Seguido más reciente",
  "Loyalty analysis": "Análisis de lealtad",
  "Can I trust these results?": "¿Puedo confiar en estos resultados?",
  "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.":
    "Sí, nuestra tecnología es la mejor en su clase y está diseñada para ser lo más precisa posible. Si no puedes obtener los resultados que buscas aquí, no los conseguirás en ningún lugar. Nuestra tecnología es la más avanzada.",
  "Is this 100% anonymous?": "¿Es esto 100% anónimo?",
  "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.":
    "Sí, no hay forma de que alguien pueda saber o ver que has buscado a una persona. Tampoco sabrán nunca que los has buscado. Hemos hecho de eso nuestra máxima prioridad.",
  "Can I catch cheaters with this?": "¿Puedo atrapar infieles con esto?",
  "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.":
    "Sí, muchas personas lo han hecho, y muchas personas han evitado terminar con el corazón roto. Puedes usar Lulu Loyal para asegurarte de no interactuar con personas que te harán daño.",
  "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.":
    "Todos los datos que recopilamos son públicos y es 100% legal recopilar estos datos e interactuar con ellos también. No estás haciendo nada que viole ninguna ley en ningún lugar al buscar a alguien.",
  "Why should I trust Lulu Loyal?": "¿Por qué debería confiar en Lulu Loyal?",
  "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.":
    "Porque hemos estado en tu lugar, y es exactamente por eso que creamos este producto. Lo que más nos importa es ayudar a otras personas a encontrar buenas personas que no las lastimen.",
  "Unlimited Searches": "Búsquedas Ilimitadas",
  "Completely Anonymous": "Completamente Anónimo",
  "No Commitment. Cancel Anytime.":
    "Sin Compromiso. Cancela en Cualquier Momento.",
  "Easy to Cancel": "Fácil de Cancelar",
  "Secured by Stripe Payments": "Asegurado por Stripe Payments",
};
